import {
  StyledMaskingText,
  StyledSectionDescription,
  StyledSectionTitle,
} from "./typography.styles";

export const MaskingText = ({ band, className, ease, speed, text }) => {
  return (
    <StyledMaskingText
      aria-label={`${text}…`}
      aria-live="polite"
      className={className}
      data-text={text}
      role="status"
      $band={band}
      $ease={ease}
      $speed={speed}
    >
      {text}
    </StyledMaskingText>
  );
};

export const SectionTitle = ({ title, ...props }) => {
  return <StyledSectionTitle {...props}>{title}</StyledSectionTitle>;
};

export const SectionDescription = ({ desc, ...props }) => {
  return <StyledSectionDescription {...props}>{desc}</StyledSectionDescription>;
};
